module.exports = __webpack_public_path__ + "img/block_04_img.a459ac24.png";